module.exports = __webpack_public_path__ + "images/undraw_Mobile_app_re_catg_1.svg";


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__mhf/images/undraw_Mobile_app_re_catg_1.svg
// module id = /tool/node_modules/file-loader/dist/cjs.js??ref--1-0!/tool/node_modules/img-loader/index.js??ref--1-1!/tool/project/client/src/site__mhf/images/undraw_Mobile_app_re_catg_1.svg
// module chunks = site__mhf